import {ENDPOINT_ADMIN_EXCHANGE_DEPOSITS_LIST} from "../../constants/api";

const CancelablePromise = require('mn-utils/CancelablePromise');
const loopMap = require('mn-utils/loopMap');
const {
  apiRequestAdmin,
} = require('../ws');

const MOCK_EXCHANGE_DEPOSITS = loopMap(100, (i) => {
  const id = '' + (1 + i);
  return {
    id: '0d5233b9-41ce-4ab4-9a9a-abab516c8aee' + id,
    login: 'ans+2000@lunu.io' + id,
    exchange_type: 'bitfinex',
    exchange_name: 'BitFinex',
    cc_code: 'ETH',
    balance: '0.03650718',
  };
});

export function apiAdminExchangeDepositsList(params) {
  params = params || {};
  const offset = params.offset || 0;
  const limit = params.limit || 50;
  if (process.env.MOCK) {
    return CancelablePromise.delay(500, {
      list: MOCK_EXCHANGE_DEPOSITS.slice(offset, offset + limit),
      count: MOCK_EXCHANGE_DEPOSITS.length,
    });
  }
  return apiRequestAdmin(ENDPOINT_ADMIN_EXCHANGE_DEPOSITS_LIST, {
    ...params,
    offset,
    limit,
  });
}
